import React from 'react';

import { BaseButton } from '@src/components/BaseButton';
import { SubmitButtonProps } from './interface';

export const SubmitButton = (props: SubmitButtonProps) => {
  return <BaseButton type="submit" {...props} />;
};
